import styled from "styled-components";

const ValueCard = ({ title, description }) => {
  return (
    <CardWrapper>
      <CardTitle>{title}</CardTitle>
      <CardDescription>{description}</CardDescription>
    </CardWrapper>
  );
};

export default ValueCard;

const CardWrapper = styled.div`
  background-color: #ffffff69;
  border-radius: 12px;
  padding: 1.25rem;
  width: 100%;

  @media (max-width: 768px) {
    min-width: 260px;
    flex-shrink: 0;
    scroll-snap-align: start;
    max-width: 90%;
  }
`;

const CardTitle = styled.h4`
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #1a1a1a;
`;

const CardDescription = styled.p`
  font-size: 0.95rem;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 1.4;
`;
